import PropTypes from 'prop-types'
import {hrefToLinkObject} from '@consteed/frontend/utils/richTextConfigurations'

const convertPwaLinkTile = (linkTile) => {
    let linkListElement = hrefToLinkObject(linkTile?.data?.link)

    linkListElement.link = linkTile?.data?.link
    linkListElement.image = linkTile?.data?.image
    linkListElement.alt = linkTile?.data?.alt
    linkListElement.c_showInMenu = true
    linkListElement.text = linkTile?.data?.text
    linkListElement.backgroundTheme = linkTile?.data?.backgroundTheme
    linkListElement.withHoverTransition = linkTile?.data?.withHoverTransition

    return linkListElement
}

const convertPwaLink = (link) => {
    let linkListElement = {
        name: link?.data?.linkText,
        linkType: link?.data?.linkType,
        c_showInMenu: true
    }
    switch (link?.data?.linkType) {
        case 'Page':
            if (!link?.data?.page) {
                return null
            }
            linkListElement.id = link?.data?.page
            break
        case 'Product':
            if (!link?.data?.product) {
                return null
            }
            linkListElement.id = link?.data?.product
            break
        case 'Category':
            if (!link?.data?.category) {
                return null
            }
            linkListElement.id = link?.data?.category
            break
        case 'Static':
            if (!link?.data?.staticResource) {
                return null
            }
            linkListElement.id = 'static'
            linkListElement.href = link?.data?.staticResource
            break
        case 'Blog':
            linkListElement.id = 'blog'
            break
        case 'ContactUs':
            linkListElement.id = 'contact'
            break
        case 'External':
        // falls through
        default:
            if (!link?.data?.externalUrl) {
                return null
            }
            linkListElement = {...linkListElement, ...hrefToLinkObject(link?.data?.externalUrl)}
    }
    return linkListElement
}

const convertSubMenu = (component) => {
    const contentRegion = component.regions.find((region) => {
        return region.id === 'content'
    })
    const linkRegion = component.regions.find((region) => {
        return region.id === 'links'
    })

    return {
        id: 'none',
        linkType: 'none',
        name: contentRegion?.components?.[0]?.data?.linkText,
        categories: linkRegion ? convertLinkRegion(linkRegion) : [],
        c_showInMenu: true
    }
}

const convertLinkRegion = (region) => {
    return region?.components
        ?.map((component) => {
            switch (component.typeId) {
                case 'custom_assets.pwaLink':
                    return convertPwaLink(component)
                case 'custom_layouts.pwaSubmenuWrapper':
                    return convertSubMenu(component)
                case 'custom_assets.pwaLinkTile':
                    return convertPwaLinkTile(component)
                default:
                    return null
            }
        })
        .filter((element) => element)
}

const convertPageRegion = (region) => {
    return convertLinkRegion(region?.components?.[0]?.regions?.[0])
}

export const convertPageToNavigationTree = ({page, createCombinedCol}) => {
    const navTree = {
        firstCol: {
            categories: []
        },
        secondCol: {
            categories: []
        },
        combinedCol: createCombinedCol
            ? {
                  categories: []
              }
            : undefined
    }

    if (page?.regions) {
        const firstRegion = page.regions.find((region) => {
            return region.id === 'first'
        })
        const secondRegion = page.regions.find((region) => {
            return region.id === 'second'
        })
        if (firstRegion) {
            navTree.firstCol.categories = convertPageRegion(firstRegion)
        }
        if (secondRegion) {
            navTree.secondCol.categories = convertPageRegion(secondRegion)
        }
        if (createCombinedCol) {
            navTree.combindedCol.categories = navTree.firstCol.categories.concat(
                navTree.secondCol.categories
            )
        }
    }
    return navTree
}

convertPageToNavigationTree.propTypes = {
    page: PropTypes.object.isRequired
}

export default convertPageToNavigationTree
